import { ShippingMethods } from '@/enums/shippingMethod';

export const LIVE_SHIPPING_METHOD_TRANSLATION_KEY = `itemPage.shippingOptions.shippingMethod.${ShippingMethods.LiveShipping}`;
